import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import jmcLogo from "../assets/jmc-logo.png";
import "../App.css";
export {}; // keep module safety

const MerchantLogin: React.FC = () => {
  const navigate = useNavigate();
  const [merchantId, setMerchantId] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setError("");

    const id = merchantId.trim();
    const pw = password.trim();

    if (!id || !pw) {
      setError("加盟店IDとパスワードを入力してください。");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("/api/merchant/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ merchant_id: id, password: pw }),
      });

      if (!res.ok) {
        let msg = "ログインに失敗しました。";
        try {
          const j = await res.json();
          if (typeof j?.detail === "string") msg = j.detail;
        } catch {}
        setError(msg);
        setLoading(false);
        return;
      }

      const json = await res.json();

      // Store merchant auth (separate from staff keys)
      localStorage.setItem("merchant_access_token", json.access_token);
      localStorage.setItem("merchant_id", json.merchant?.merchant_id || id);
      localStorage.setItem("merchant_company_name", json.merchant?.company_name || "");

      setLoading(false);

      // Next screen (we will create next step)
      navigate("/merchant/dashboard");
    } catch {
      setError("ログインに失敗しました。バックエンドが起動しているか確認してください。");
      setLoading(false);
    }
  };

  return (
    <div className="ml-page">
      <header className="ml-topbar">
        <div className="ml-left" onClick={() => navigate("/")} role="button" tabIndex={0}>
          <img src={jmcLogo} alt="JMC" className="ml-logo" />
          <div className="ml-brand">
            <div className="ml-brand-name">JMC</div>
            <div className="ml-brand-sub">加盟店登録ポータル</div>
          </div>
        </div>

        <button className="ml-back" onClick={() => navigate("/")}>
          戻る
        </button>
      </header>

      <main className="ml-main">
        <div className="ml-card">
          <div className="ml-card-header">
            <div className="ml-card-title">加盟店ログイン</div>
            <div className="ml-card-sub">
              JMCから案内された加盟店IDとパスワードでログインしてください。
            </div>
          </div>

          <div className="ml-form">
            {error && (
              <div
                style={{
                  marginBottom: 12,
                  background: "#fff1f2",
                  border: "1px solid #fecdd3",
                  color: "#b91c1c",
                  padding: "10px 12px",
                  borderRadius: 12,
                  fontWeight: 800,
                }}
              >
                {error}
              </div>
            )}

            <label className="ml-label">加盟店ID</label>
            <input
              className="ml-input"
              value={merchantId}
              onChange={(e) => setMerchantId(e.target.value)}
              placeholder="例）M42519816"
              disabled={loading}
            />

            <label className="ml-label">パスワード</label>
            <input
              className="ml-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              disabled={loading}
            />

            <button
              className="ml-login-btn"
              onClick={handleLogin}
              disabled={!merchantId || !password || loading}
              title={!merchantId || !password ? "IDとパスワードを入力してください" : ""}
            >
              {loading ? "ログイン中..." : "ログイン"}
            </button>

            <div className="ml-help">
              お困りの場合：担当のJMCスタッフまでご連絡ください。
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MerchantLogin;
